import React, {Component} from 'react'
import ReturnNav from "../../../components/single_components/ReturnNav";
import '../../../components_style/rtl_css/PatientForm.css'
import '../../../components_style/PatientForm.css'
import utils from "../../../utils/utils";
import * as Yup from "yup";
import validationHelper from "../../../utils/validationHelper";
import FormElementContainer from "../../../components/forms_builder/FormElementContainer";
import {makeError} from "../../../components/modals/ErrorModal";
import AlertConfirm from "../../../components/modals/Confirm";
import AllUsersApi from "../../../services/ApiServices/AllUsersApi";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import RegisterPatientDetails from "../../../components/single_components/RegisterPatientDetails";
import SvGraphics from "../../../assets/SvGraphics";
import Error from "../../../components/single_components/Error";
import Config from "../../../config/Config";
import PhoneInput from "react-phone-input-2";
import ReCaptcha from "../ReCaptcha";
import {authenticationService} from "../../../services/AuthenticationService";
import ReactFlagsSelect from "react-flags-select";
import Translate from "../../../utils/Translate";
import LeumitLogo from "../../../assets/LeumitLogo.png"
import {appendIchilovQuery, hasIchilovQuery} from "../../../utils/routeUtils";
import ichilovImg from "../../../assets/Soraski.svg";

class ApprovingClinicRegComposed extends Component {

    constructor(props) {
        super(props);
        this.recaptchaRef = React.createRef()

        this.state = {
            entry: {
                ID_passport: "",
                First_name: "",
                Last_name: "",
                Email: "",
                Phone_num1: "",
                Insuring_factor: "",
                reCaptchaToken: "",
                termOfUseSigned: false,
                sendMarketOffers: false,
                ichilov: false
            },
            errors: {},
            errorsOnSave: {},
        }
    }

    initValidation = async () => {
        let {t} = this.props
        let EmailRegex = {Email: Yup.string().matches(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, t('defaults.Registration.invalidMail'))}
        if (!this.state.entry.Email) {
            EmailRegex = {Email: Yup.string().nullable()}
        }
        let validationSchema = Yup.object().shape({
            ID_passport: Yup.string().required(t('defaults.Registration.mandatoryField')).matches(/^\d+$/, t('defaults.Registration.digitsOnly')).test('len', t('defaults.Registration.nineCharacters'), val => val.length === 9),
            First_name: Yup.string().required(t('defaults.Registration.mandatoryField')),
            Last_name: Yup.string().required(t('defaults.Registration.mandatoryField')),
            Phone_num1: Yup.string().required('This field is mandatory').matches(/^\d+$/, 'The field should have digits only'),
            Insuring_factor: Yup.string().required(t('defaults.Registration.mandatoryField')),
            ...EmailRegex,
            confirmPhone: Yup.string().required(t('defaults.Registration.mandatoryField'))
                .oneOf([Yup.ref('Phone_num1'), null], t('defaults.Registration.phoneMustMatch')),

        })


        let errors = await validationHelper.validate(this.state.entry, validationSchema)
        await this.setState({
            validationSchema,
            errors
        })

    }

    componentDidMount = () => {
        let {entry} = this.state
        let flag = hasIchilovQuery()
        entry['IsIchilov'] = flag
        this.setState({entry, ichilov: flag})

    }

    onNavBack = async (isClose) => {
        if (isClose) {
            let confirm = await AlertConfirm({
                options: {
                    title: `Withdraw data`,
                }
            }, `Are you sure you want to withdraw the data you've entered?`)
            if (confirm) {
                this.props.history.push(appendIchilovQuery('/login_pain'))
            }
        } else {
            this.props.history.push(appendIchilovQuery('/login_pain_reg'))
        }
    }

    onValueChange = async (name, value) => {
        let {entry, validationSchema} = this.state
        if (name === "Email" && (value === "" || value === null)) {
            value = null
        }
        utils.set(entry, name, value)

        let errors = await validationHelper.validate(entry, validationSchema);
        let errorsOnSave = this.state.errorsOnSave;

        if (JSON.stringify(errors) === '{}') {
            errorsOnSave = errors
        }

        if (utils.get(errorsOnSave, name)) {
            utils.set(errorsOnSave, name, utils.get(errors, name))
        }

        this.setState({
            entry,
            errors,
            errorsOnSave
        })
    }
    saveEntry = async () => {
        await this.recaptchaRef.reset()
        await this.recaptchaRef.execute()
    }

    submitData = async (reCaptchaToken) => {
        let {t} = this.props
        await this.initValidation()

        if (!utils.isEmpty(this.state.errors)) {
            this.setState({errorsOnSave: this.state.errors});
            await makeError({
                proceedLabel: 'Ok',
                options: {
                    title: t('defaults.Registration.couldNotSaveData'),
                }
            }, [t('defaults.Registration.fillRequiredFields')]);
            return;
        }
        let {entry} = this.state

        if (!entry.termOfUseSigned) {
            let confirm = await AlertConfirm({
                options: {
                    cancelLabel: "none",
                    proceedLabel: t('defaults.rst_pwd.Ok'),
                    title: t('defaults.crt_pwd.termofuse_title'),
                }
            }, t('defaults.crt_pwd.termofuse_req'))
            return
        }

        entry = utils.ObjectEmptiesToNulls(entry)
        entry = utils.removeEmptyOrNull(entry)
        // let confirm = await AlertConfirm({
        //     options: {
        //         title: `Registration details`,
        //     }
        // }, `Are you sure you wish to create a new user in leumit?`)
        // if (confirm) {

        if (this.state.entry.IsIchilov) {
            let confirm = await AlertConfirm({
                options: {
                    title: `יצירת חשבון`,
                    proceedLabel: 'אישור',
                    cancelLabel: 'ביטול'
                }
            }, ' אופציה זו אפשרית רק למטופלים בעלי המלצה עדכנית מבית החולים איכילוב')
            if (!confirm)
                return
        }


        if (entry.Phone_num1 && !entry.Phone_num1.includes('972')) {
            entry.Phone_num1 = "972" + entry.Phone_num1.substring(1)
        }
        entry['reCaptchaToken'] = reCaptchaToken
        let response = await AllUsersApi.selfRegisterApproving(entry)
        if (response && response.status === 200 && response.data.status === 200) {
            let responseLogin = await authenticationService.PatientLogin(entry.ID_passport, entry.Phone_num1, reCaptchaToken);
            if (responseLogin) {
                let data = {Phone_num1: entry.Phone_num1, ID_passport: entry.ID_passport}
                this.setState({entry: {}})
                this.props.history.push({
                    pathname: appendIchilovQuery(`/pain_patient_2FA`),
                    state: {
                        data,
                        from: {
                            fromPath: `/register_pain`,
                        }
                    },
                })
            }
        } else if (response && response.data && response.data.status === 400) {
            await AlertConfirm({
                options: {
                    cancelLabel: "none",
                    title: t('patient_boarding.mediator'),
                }
            }, t('patient_boarding.mediatorError'))

        } else if (response && response.status === 260) {
            await AlertConfirm({
                options: {
                    cancelLabel: "none",
                    title: t('defaults.Registration.registration_info'),
                }
            }, t('defaults.Registration.patientEmailExists'))
        } else {
            await AlertConfirm({
                options: {
                    cancelLabel: "none",
                    proceedLabel: t('patient_boarding.ok'),
                    title: t('defaults.Registration.registration_info'),
                }
            }, t('defaults.Registration.patientExists'))
        }
        // }
    }

    goBack() {
        this.props.history.push(appendIchilovQuery('/login_pain'))
    }

    gotoPatientLogin() {
        this.props.history.push(appendIchilovQuery('/pain_patient_login'))
    }

    componentDidUpdate() {
        const myInput = document.getElementById('Phone-Confirm');
        myInput.onpaste = e => e.preventDefault();
    }

    setCheckBox = async (e, name) => {
        let {entry} = this.state
        entry[name] = !entry[name]
        entry['Insuring_factor'] = ""
        this.setState({entry})
    }

    setIchilovCheckBox = async (e, name) => {
        let {entry} = this.state
        entry[name] = !entry[name]
        console.log("setIchilovCheckBox",entry[name])
        if(entry[name]){
            this.props.history.push('/register_pain?ichilov=true')
        }else{
            this.props.history.push('/register_pain')
        }
        this.setState({entry})
    }

    setTermsOfUseSigned = (e) => {
        let {entry} = this.state
        entry.termOfUseSigned = !entry.termOfUseSigned
        this.setState({entry})
    }
    setSendMerketOffers = async (e) => {
        let {entry} = this.state
        entry.sendMarketOffers = !entry.sendMarketOffers
        this.setState({entry})
    }

    getInsureFactorOptions = () => {
        let {entry} = this.state
        let {t} = this.props
        if (!entry['IsIchilov']) {
            return (<>
                <option value="" disabled
                        selected>{t('patient_self_boarding.Insurance')}</option>
                <option value={"3"}>{t('patient_self_boarding.Leumit')}</option>
                <option disabled={true} value={"1"}>{t('patient_self_boarding.Maccabi')} -
                    השירות אינו ניתן בשלב זה
                </option>
                <option disabled={true} value={"2"}>{t('patient_self_boarding.Clalit')} - השירות
                    אינו ניתן בשלב זה
                </option>
                <option disabled={true} value={"4"}>{t('patient_self_boarding.Meuhedet')} -
                    השירות אינו ניתן בשלב זה
                </option>
                <option disabled={true}
                        value={"5"}>{t('patient_self_boarding.InsuranceCompany')} - השירות אינו
                    ניתן בשלב זה
                </option>
                <option disabled={true} value={"6"}>{t('patient_self_boarding.IDF')} - השירות
                    אינו ניתן בשלב זה
                </option>
                <option disabled={true}
                        value={"7"}>{t('patient_self_boarding.MinistryOfDefence')} - השירות אינו
                    ניתן בשלב זה
                </option>
                <option disabled={true} value={"8"}>{t('patient_self_boarding.None')} - השירות
                    אינו ניתן בשלב זה
                </option>
                <option disabled={true}
                        value={"9"}>{t('patient_self_boarding.PalestinianAuthority')} - השירות
                    אינו ניתן בשלב זה
                </option>
                <option disabled={true} value={"10"}>{t('patient_self_boarding.other')} - השירות
                    אינו ניתן בשלב זה
                </option>
            </>)
        } else {
            return (<>
                <option value="" disabled
                        selected>{t('patient_self_boarding.Insurance')}</option>
                <option value={"3"}>{t('patient_self_boarding.Leumit')}</option>
                <option value={"1"}>{t('patient_self_boarding.Maccabi')}
                </option>
                <option value={"2"}>{t('patient_self_boarding.Clalit')}
                </option>
                <option value={"4"}>{t('patient_self_boarding.Meuhedet')}
                </option>
                <option
                    value={"5"}>{t('patient_self_boarding.InsuranceCompany')}
                </option>
                <option value={"6"}>{t('patient_self_boarding.IDF')}
                </option>
                <option
                    value={"7"}>{t('patient_self_boarding.MinistryOfDefence')}
                </option>
                <option value={"8"}>{t('patient_self_boarding.None')}
                </option>
                <option
                    value={"9"}>{t('patient_self_boarding.PalestinianAuthority')}
                </option>
                <option value={"10"}>{t('patient_self_boarding.other')}
                </option>
            </>)
        }
    }

    async onSelectFlag(e) {
        e = e && e.length > 0 ? e : "he"
        localStorage.setItem('language', e)
        let lang = Translate.getLanguage(e);
        let language = await Translate.setLanguageLocal(lang);
        const {i18n} = this.props;
        await i18n.changeLanguage(language);
        if (Translate.rtl.includes(language)) document.getElementsByTagName("html")[0].setAttribute("dir", "rtl")
        else document.getElementsByTagName("html")[0].setAttribute("dir", "ltr")
    }

    render() {
        let {errorsOnSave, entry} = this.state
        let {t} = this.props
        return (
            <div className={"login-page-Leumit"}>
                <div className={'sade-right-changeLang'}>
                    <ReactFlagsSelect selectButtonClassName={'language-select-button'}
                                      className={'sade-right-navbar-content'}
                                      placeholder={t('patient_boarding.choose_language')}
                                      defaultCountry={Translate.getCurrentCountry()}
                                      countries={Translate.getCountries()} showSelectedLabel={true}
                                      showOptionLabel={true} selectedSize={14}
                                      selected={Translate.getCurrentCountry(localStorage.getItem('language'))}
                                      onSelect={e => this.onSelectFlag(e)}
                                      customLabels={{
                                          "US": "EN",
                                          "IL": "עב",
                                      }}
                    />
                </div>
                <div className={'sade-Pain-reg-login-logo-container '}>
                    <SvGraphics svgname={'painClinicLogo'} className={'sade-Pain-login-logo'}/>
                    {hasIchilovQuery() ? <img src={ichilovImg} className={'sade-Pain-login-logo'} alt={""}/> :
                        <img src={LeumitLogo} className={'sade-Pain-login-logo'} alt={""}/>
                    }

                    <ReactFlagsSelect selectButtonClassName={'language-select-button'}
                                      className={'sade-right-language-content'}
                                      placeholder={t('patient_boarding.choose_language')}
                                      defaultCountry={Translate.getCurrentCountry()}
                                      countries={Translate.getCountries()} showSelectedLabel={true}
                                      showOptionLabel={true} selectedSize={14}
                                      selected={Translate.getCurrentCountry(localStorage.getItem('language'))}
                                      onSelect={e => this.onSelectFlag(e)}
                                      customLabels={{
                                          "US": "EN",
                                          "IL": "עב",
                                      }}
                    />
                </div>
                <div className={'sade-Pain-registration-main-board'}>
                    <div className={'sade-welcome-label'}>{t('defaults.Registration.welcome_asaya')}</div>
                    <div className={'sade-login-label2'}>{t('defaults.Registration.fast_applciation')}</div>

                    <div className={'sade-login-label3'}>{t('defaults.Registration.mail_notice')}</div>
                    <div className={'sade-Pain-reg-form'}>
                        <div className={'sade-Pain-registration-inputs-flex'}>
                            <div className={'sade-Pain-registration-input-svg'}>
                                <Error isNonFloat={true}
                                       errorMessage={utils.get(this.state.errorsOnSave, 'First_name')}
                                       isShown={!!utils.get(this.state.errorsOnSave, 'First_name')}/>
                                <div className={"login-input-wrapper form-group leumit-login-form-group"}>
                                    <input className={"sade-registration-input-fields"}
                                           placeholder={t('defaults.Registration.First_name')}
                                           name={"First_name"}
                                           defaultValue={entry.First_name}
                                           onChange={(event) => this.onValueChange("First_name", event.target.value)}
                                    />
                                    <SvGraphics
                                        className={!!utils.get(this.state.errorsOnSave, 'First_name') ? "input-pic-reg2" : "input-pic-reg"}
                                        svgname={'person'}
                                        style={{width: '20px', height: '20px'}}/>
                                </div>

                            </div>

                            <div className={'sade-Pain-registration-input-svg'}>
                                <Error isNonFloat={true}
                                       errorMessage={utils.get(this.state.errorsOnSave, 'Last_name')}
                                       isShown={!!utils.get(this.state.errorsOnSave, 'Last_name')}/>
                                <div className={"login-input-wrapper form-group leumit-login-form-group"}>
                                    <input className={"sade-registration-input-fields"}
                                           placeholder={t('defaults.Registration.Last_name')}
                                           name={"Last_name"}
                                           defaultValue={entry.Last_name}
                                           onChange={(event) => this.onValueChange("Last_name", event.target.value)}
                                    />
                                    <SvGraphics
                                        className={!!utils.get(this.state.errorsOnSave, 'Last_name') ? "input-pic-reg2" : "input-pic-reg"}
                                        svgname={'person'}
                                        style={{width: '20px', height: '20px'}}/>
                                </div>

                            </div>

                        </div>

                        <div className={'sade-Pain-registration-inputs-flex'}>
                            <div className={'sade-Pain-registration-input-svg'}>
                                <Error isNonFloat={true}
                                       errorMessage={utils.get(this.state.errorsOnSave, 'ID_passport')}
                                       isShown={!!utils.get(this.state.errorsOnSave, 'ID_passport')}/>
                                <div className={"login-input-wrapper form-group leumit-login-form-group"}>
                                    <input className={"sade-registration-input-fields"}
                                           name={"ID_passport"}
                                           value={entry.ID_passport}
                                           placeholder={t('defaults.Registration.ID_passport')}
                                           maxLength={9}
                                           onChange={(event) => this.onValueChange("ID_passport", event.target.value)}
                                    />
                                    <SvGraphics
                                        className={!!utils.get(this.state.errorsOnSave, 'ID_passport') ? "input-pic-reg2" : "input-pic-reg"}
                                        svgname={'idPass'}
                                        style={{width: '20px', height: '20px'}}/>
                                </div>

                            </div>
                            <div className={'sade-Pain-registration-input-svg'}>
                                <Error isNonFloat={true} errorMessage={utils.get(this.state.errorsOnSave, 'Email')}
                                       isShown={!!utils.get(this.state.errorsOnSave, 'Email')}/>
                                <div className={"login-input-wrapper form-group leumit-login-form-group"}>
                                    <input className={"sade-registration-input-fields"}
                                           placeholder={t('defaults.Registration.Email')}
                                           name={"Email"}
                                           defaultValue={entry.Email}
                                           onChange={(event) => this.onValueChange("Email", event.target.value)}
                                    />
                                    <SvGraphics
                                        className={!!utils.get(this.state.errorsOnSave, 'Email') ? "input-pic-reg2" : "input-pic-reg"}
                                        svgname={'email-icon'}
                                        style={{width: '20px', height: '20px'}}/>
                                </div>

                            </div>


                        </div>
                        <div className={'sade-Pain-registration-inputs-flex'}>

                            <div className={'sade-Pain-registration-input-svg'}>
                                <Error isNonFloat={true} errorMessage={utils.get(this.state.errorsOnSave, 'Phone_num1')}
                                       isShown={!!utils.get(this.state.errorsOnSave, 'Phone_num1')}/>
                                <div className={"login-input-wrapper form-group leumit-login-form-group"}>
                                    <input className={"sade-registration-input-fields"}
                                           placeholder={t('defaults.Registration.Phone')}
                                           name={"Phone_num1"}
                                           value={entry.Phone_num1}
                                           onChange={(event) => this.onValueChange("Phone_num1", event.target.value)}
                                    />
                                    <SvGraphics
                                        className={!!utils.get(this.state.errorsOnSave, 'Phone_num1') ? "input-pic-reg2" : "input-pic-reg"}
                                        svgname={'smartPhone'}
                                        style={{width: '20px', height: '20px'}}/>
                                </div>

                            </div>


                            <div className={'sade-Pain-registration-input-svg'}>
                                <Error isNonFloat={true}
                                       errorMessage={utils.get(this.state.errorsOnSave, 'confirmPhone')}
                                       isShown={!!utils.get(this.state.errorsOnSave, 'confirmPhone')}/>
                                <div className={"login-input-wrapper form-group leumit-login-form-group"}>
                                    <input className={"sade-registration-input-fields"}
                                           placeholder={t('defaults.Registration.confirmPhone')}
                                           name={"confirmPhone"}
                                           id={"Phone-Confirm"}
                                           defaultValue={entry.confirmPhone}
                                           onChange={(event) => this.onValueChange("confirmPhone", event.target.value)}
                                    />
                                    <SvGraphics
                                        className={!!utils.get(this.state.errorsOnSave, 'Phone_num1') ? "input-pic-reg2" : "input-pic-reg"}
                                        svgname={'smartPhone'}
                                        style={{width: '20px', height: '20px'}}/>
                                </div>

                            </div>

                        </div>
                        <div className={"login-input-wrapper form-group sade-login-form-checkboxes"}
                             style={{display: 'flex'}}>
                            <input
                                type="checkbox"
                                checked={this.state.ichilov || this.state.entry.IsIchilov}
                                onChange={e => this.setIchilovCheckBox(e, 'IsIchilov')}
                                style={{marginTop: '8px', width: '19px', height: '19px', transform: 'scale(1)'}}
                            />
                            <label className={'termsofuse'}>
                                למטופלים בעלי המלצה מהמרכז הרפואי סוראסקי - איכילוב בלבד.</label>
                        </div>

                        <div className={'sade-Pain-registration-inputs-flex'}>
                            <div className={'sade-Pain-registration-input'}>
                                <Error isNonFloat={true}
                                       errorMessage={utils.get(this.state.errorsOnSave, 'Insuring_factor')}
                                       isShown={!!utils.get(this.state.errorsOnSave, 'Insuring_factor')}/>
                                <div className={"login-input-wrapper form-group leumit-login-form-group"}>
                                    <select className={'selectBoxRegistration'} id="InsuranceType" name="InsuranceType"
                                            value={entry.Insuring_factor}
                                            onChange={(event) => this.onValueChange("Insuring_factor", event.target.value)}>

                                        {this.getInsureFactorOptions()}

                                    </select>
                                    <SvGraphics
                                        className={!!utils.get(this.state.errorsOnSave, 'Insuring_factor') ? "input-pic-reg2" : "input-pic-reg"}
                                        svgname={'insurance'}
                                        style={{width: '20px', height: '20px'}}/>
                                </div>

                            </div>
                            {/*<div className={'sade-Pain-registration-input-svg'}>
                                <Error isNonFloat={true}
                                       errorMessage={utils.get(this.state.errorsOnSave, 'MediatorCode')}
                                       isShown={!!utils.get(this.state.errorsOnSave, 'MediatorCode')}/>
                                <div className={"login-input-wrapper form-group leumit-login-form-group"}>
                                    <input className={"sade-registration-input-fields"}
                                           placeholder={t('admin.mediator.MediatorCodeEntry')}
                                           name={"MediatorCode"}
                                           maxLength={6}
                                           id={"MediatorCode"}
                                           defaultValue={entry.MediatorCode}
                                           onChange={(event) => this.onValueChange("MediatorCode", event.target.value)}
                                    />
                                    <SvGraphics
                                        className={!!utils.get(this.state.errorsOnSave, 'MediatorCode') ? "input-pic-reg2" : "input-pic-reg"}
                                        svgname={'pinCode'}
                                        style={{width: '20px', height: '20px'}}/>
                                </div>

                            </div>*/}

                        </div>


                        <div className={"login-input-wrapper form-group sade-login-form-checkboxes"}
                             style={{display: 'flex'}}>
                            <input
                                type="checkbox"
                                onChange={e => this.setTermsOfUseSigned(e)}
                                style={{marginTop: '8px', width: '19px', height: '19px', transform: 'scale(1)'}}
                            />
                            <label className={'termsofuse'}>
                                {t('defaults.crt_pwd.termOfUse')}
                                <a target="_blank" style={{color: '#000000'}}
                                   href="https://sade-terms.s3.eu-central-1.amazonaws.com/%D7%AA%D7%A0%D7%90%D7%99+%D7%A9%D7%99%D7%9E%D7%95%D7%A9++ASAYApp+R01.pdf">
                                    {t('defaults.crt_pwd.termOfUse1')}</a>
                                {t('defaults.crt_pwd.and')}
                                <a target="_blank" style={{color: '#000000'}}
                                   href="https://sade-terms.s3.eu-central-1.amazonaws.com/%D7%9E%D7%93%D7%99%D7%A0%D7%99%D7%95%D7%AA+%D7%A4%D7%A8%D7%98%D7%99%D7%95%D7%AA++ASAYApp+R01.pdf">
                                    {t('defaults.crt_pwd.termOfUse2')}</a>
                                {t('defaults.crt_pwd.termOfUse3')}</label>
                        </div>
                        <div className={"login-input-wrapper form-group sade-login-form-checkboxes2"}
                             style={{display: 'flex'}}>
                            <input
                                type="checkbox"
                                onChange={e => this.setSendMerketOffers(e)}
                                style={{marginTop: '8px', width: '19px', height: '19px', transform: 'scale(1)'}}
                            />
                            <label className={'termsofuse'}>{t('defaults.Registration.marketsOffer')} </label>
                        </div>
                        <div className="form-group leumit-login-form-group">
                            <button className="sade-registration-form-button"
                                    onClick={this.saveEntry.bind(this)}>{t('defaults.Registration.save')}</button>
                        </div>
                        <div className="leumit-login-selection">
                            <div className={'account-exists-block'} onClick={() => this.gotoPatientLogin()}>
                                <SvGraphics svgname={'enter'}
                                            style={{minWidth: '14px', width: '14px', marginTop: '-6px'}}/>
                                <div className="account-exists">{t('defaults.Registration.acc_exists')}</div>
                            </div>
                            <div className={"account-exists-space"}/>
                            <div className={'account-exists-block'} onClick={() => this.goBack()}>
                                <SvGraphics svgname={'stethoscope'}
                                            style={{minWidth: '14px', width: '14px', marginTop: '-6px'}}/>
                                <div className="account-exists"
                                >{t('defaults.Registration.doctor_signIn')}</div>
                            </div>
                        </div>

                    </div>

                    <div className={'leumit-login-form-group loginError red h-centered'}>
                        <Error isNonFloat={true}
                               errorMessage={t('defaults.Registration.reg_err') + ': ' + this.state.errMessage}
                               isShown={this.state.isErr}/>
                    </div>

                </div>

                <div className={'sade-Pain-bottom-container2'}>
                    <div className="need-help-label">
                        {t('defaults.Registration.need_help')}
                    </div>

                    <div className="need-help-block">

                        <div className="need-help-block-content">
                            <SvGraphics svgname={'global'} className={"login-website-icon"}/>

                            <div className={"login-website-div"}>
                                <a className={"login-website-label"} target={"_blank"}
                                   href={'https://www.sade.group/he/pain'}>www.sade.group</a>
                            </div>

                        </div>
                        <div className="need-help-block-content">
                            <SvGraphics svgname={'email-icon'} className={"login-website-icon"}/>

                            <div className={"login-website-div"}>

                                <a className={"login-website-label"}
                                   href="mailto: pain@sade.group">pain@sade.group</a>
                            </div>

                        </div>


                        <div className="need-help-block-content">
                            <SvGraphics svgname={'phone-icon'} className={"login-website-icon"}/>

                            <div className={"login-website-div"}>
                                <a className={"login-website-label"} href="tel:073-380-7972">073-380-7972</a>
                            </div>
                        </div>
                        <div className="need-help-block-content">
                            <SvGraphics svgname={'clock'} className={"login-website-icon"}/>

                            <div className={"login-website-div"}>

                                <a className={"login-website-label"}
                                   href="">{t('patient_self_boarding.workingHours')}</a>
                            </div>

                        </div>
                    </div>
                </div>


                <div className={'login-version-element'}>
                    <div className={'login-version-element-label'}>Version:</div>
                    <div className={'login-version-element-value'}>{Config.version} {Config.build}</div>
                </div>

                <div className={'recaptcha-block'}>
                    <ReCaptcha setRef={ref => (this.recaptchaRef = ref)}
                               action={async (reCaptchaToken) => {
                                   await this.submitData(reCaptchaToken);
                               }}
                        /*setErr={ this.setRecapchaErrors()}*//>
                </div>

            </div>

        )
    }
}


let ApprovingClinicReg = compose(
    withTranslation()
)(ApprovingClinicRegComposed)
export default ApprovingClinicReg;
